import { useMutation, useQueryClient } from '@tanstack/react-query';
import { promotionsService } from '../services/promotions.service';
import type { PromotionStatus } from '../types/promotions.types';

export function useUpdatePromotionStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ refId, status }: { refId: string; status: PromotionStatus }) =>
      promotionsService.updatePromotionStatus(refId, status),
    onSuccess: (_, { refId }) => {
      queryClient.invalidateQueries({ queryKey: ['promotions'] });
      queryClient.invalidateQueries({ queryKey: ['promotion', refId] });
    },
  });
}
